<script setup lang="ts">
import { computed } from "vue";

import moment from "moment";

import type { InterviewPopoverData } from "@/components/following/types";

interface Props {
    data: InterviewPopoverData;
}

const props = defineProps<Props>();

const formattedDate = computed(() => moment(props.data.scheduledAt).locale("fr").format("D MMM"));

const formattedTime = computed(() => {
    const start = moment(props.data.scheduledAt).format("HH[h]");
    if (props.data.scheduledEndAt) {
        const end = moment(props.data.scheduledEndAt).format("HH[h]");
        return `${start} - ${end}`;
    }

    return start;
});
</script>

<template>
    <div class="interview-popover">
        <div class="interview-popover__bar" :style="{ backgroundColor: data.accentColor }" />
        <div class="interview-popover__content">
            <span class="interview-popover__date typo-sm-medium">{{ formattedDate }}</span>
            <span class="interview-popover__time typo-xxs-regular">{{ formattedTime }}</span>
            <span class="interview-popover__person typo-xxs-regular">{{ data.madeBy }}</span>
        </div>
    </div>
</template>

<style scoped lang="scss">
.interview-popover {
    display: flex;
    gap: var(--spacing-lg, 12px);
    align-items: stretch;
    min-height: 40px;

    &__bar {
        width: 4px;
        border-radius: var(--radius-xl, 8px);
        flex-shrink: 0;
    }

    &__content {
        display: flex;
        flex: 1;
        flex-direction: column;
        gap: var(--spacing-xxs, 2px);
        padding: var(--spacing-xxs, 2px) 0;
    }

    &__date {
        color: var(--text-main-900, #00061a);
    }

    &__time {
        color: var(--text-sub-600, #494e61);
    }

    &__person {
        padding-top: var(--spacing-md, 8px);
        color: var(--text-sub-600, #494e61);
    }
}
</style>
